<div class="admin-user-preview-container" fxLayout="column">
  <mat-card class="user-profile">
    <mat-card-content>
      <div class="user-info-container" fxLayout="row">
        <div
          class="user-info mat-elevation-z2"
          fxLayout="column"
          fxFlex="20"
          fxLayoutAlign="center center"
        >
          <div class="profile-image">
            <img
              referrerpolicy="no-referrer"
              [src]="
                userReport.avatar_url ||
                'assets/image/user-avatar-placeholder.jpg'
              "
              alt=""
            />
          </div>
          <div class="profile-user-name">
            <span>{{ userReport.user_fullName }}</span>
          </div>
        </div>

        <div class="user-details mat-elevation-z2" fxFlex="80">
          <div
            class="info-blocks"
            fxLayout="row wrap"
            fxLayoutAlign="space-between start"
            fxFlex="100"
          >
            <div
              class="info-block"
              fxFlex="49"
              fxFlex.lt-sm="100"
              fxLayout="column"
            >
              <!-- <div
                class="block"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div class="title" fxFlex="50">شماره کاربری</div>
                <div class="data" fxFlex="50">{{ userReport.user_id }}</div>
              </div> -->
              <div
                class="block"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div class="title" fxFlex="50">وضعیت کاربر</div>
                <div class="data" fxFlex="50">
                  <mat-slide-toggle
                    [(ngModel)]="userReport.user_active"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="changeUserActivation($event)"
                  />
                </div>
              </div>

              <div
                class="block"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div class="title" fxFlex="50">وضعیت تایید کاربر</div>
                <div class="data" fxFlex="50">
                  <mat-slide-toggle
                    [(ngModel)]="userReport.user_verified"
                    [ngModelOptions]="{ standalone: true }"
                    disabled
                  />
                </div>
              </div>

              <div
                class="block"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div class="title" fxFlex="50">نام کامل</div>
                <div class="data" fxFlex="50">
                  {{ userReport.user_fullName }}
                </div>
              </div>

              <div
                class="block"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div class="title" fxFlex="50">تلفن یا ایمیل</div>
                <div class="data" fxFlex="50">
                  {{ userReport.user_phone || userReport.user_email }}
                </div>
              </div>
            </div>

            <div
              class="info-block"
              fxFlex="49"
              fxFlex.lt-sm="100"
              fxLayout="column"
            >
              <div
                class="block"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div class="title" fxFlex="50">نقش کاربر</div>
                <div class="data" fxFlex="50">
                  <span *ngIf="userReport?.role_code">{{ userRoles[userReport.role_code] }}</span>
                </div>
              </div>
              <div
                class="block"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div class="title" fxFlex="50">ارزش کل مشتری</div>
                <div class="data" fxFlex="50">
                  {{ userReport.totalvalue | irc : "T" }}
                </div>
              </div>

              <div
                class="block"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div class="title" fxFlex="50">شارژ کیف پول</div>
                <div class="data" fxFlex="50">
                  {{ userReport.wallet_balance | irc : "T" }}
                </div>
              </div>

              <div
                class="block"
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                <div class="title" fxFlex="50">مجموع امتیازات</div>
                <div class="data" fxFlex="50">
                  {{ userReport.user_score || 0 + " امتیاز" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end gap-2">
        <button mat-raised-button *ngIf="userReport.role_code !== userRoles.USER" (click)="changeRole(userRoles.USER)">تغییر نقش به کاربر</button>
        <button mat-raised-button *ngIf="userReport.role_code !== userRoles.MANAGER" (click)="changeRole(userRoles.MANAGER)">تغییر نقش به مدیر</button>
        <button mat-raised-button *ngIf="userReport.role_code !== userRoles.ADMIN" (click)="changeRole(userRoles.ADMIN)">تغییر نقش به ادمین</button>
      </div>
    </mat-card-content>
  </mat-card>
  <mat-tab-group mat-align-tabs="center" mat-stretch-tabs>
    <mat-tab label="تاریخچه خرید">
      <admin-user-order-history [userId]="userReport.user_id" />
    </mat-tab>

    <mat-tab label="تراکنش‌ها">
      <admin-transactions [targetUser]="user?.id!" />
    </mat-tab>

    <mat-tab label="فایل‌های اشتراکی">
      <admin-user-shared-files-list [userReport]="userReport" />
    </mat-tab>

    <!-- <mat-tab label="بسته‌ها">
      <shared-user-activated-discount-container
        [discounts]="userDiscounts"
        title=""
      ></shared-user-activated-discount-container>
    </mat-tab> -->
    <mat-tab label="امتیازات">
      <admin-user-scores-list [userReport]="userReport" />
    </mat-tab>
    <mat-tab label="کد تخفیف">
      <admin-user-discount-list [userReport]="userReport" />
    </mat-tab>
  </mat-tab-group>
</div>
